import { ReactNode } from "react";
import { getSectionIcon } from "@/client/pages/builder/sidebar/sections/shared/section-icon";
import { ExtendedSectionKey } from "@/client/pages/builder/sidebar/sections/shared/section-icon";
import { cn } from "@reactive-resume/utils";

type Props = {
  icon: ExtendedSectionKey;
  title: string;
  extra?: ReactNode;
  className?: string;
};

export const SectionHeader = ({ icon, title, extra, className }: Props) => {
  return (
    <header className={cn("flex w-full items-center justify-between", className)}>
      <div className="flex items-center gap-x-2">
        {getSectionIcon(icon, {
          size: 26,
          weight: "duotone",
          className: "text-secondary/40 relative -left-1",
        })}
        <h2 className="line-clamp-1 text-lg font-bold lg:text-lg">{title}</h2>
      </div>
      {extra && extra}
    </header>
  );
};
